<div class="modal-dependents">
  <div class="modal-header">
  <h4 class="modal-title" id="myModalLabel1">{{ documentOnlyView ? 'Documento da Ausência' : 'Qualificação de Ausência' }}</h4>
  <button type="button" (click)="onDismiss()" class="close" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" tabindex="0" ngbAutofocus>
  <div *ngIf="isInitializing" class="text-center py-5">
    <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
    <p class="mt-2 mb-0 text-muted">Carregando...</p>
  </div>

  <ng-template #documentPreview>
    <iframe *ngIf="documentPreviewUrl && isPdf()" [src]="documentPreviewUrl" frameborder="0"
      class="flex-grow-1 border rounded document-preview-frame"></iframe>
    <div *ngIf="documentPreviewUrl && isImage()"
      class="flex-grow-1 d-flex justify-content-center border rounded document-preview-image"
      [class.is-zoomed]="imageZoom > minImageZoom"
      [class.is-panning]="isPanning"
      (wheel)="onPreviewWheel($event)"
      (pointerdown)="onPreviewPointerDown($event)"
      (pointermove)="onPreviewPointerMove($event)"
      (pointerup)="onPreviewPointerUp()"
      (pointercancel)="onPreviewPointerUp()">
        <img
          #documentPreviewImage
          [src]="documentPreviewUrl"
          alt="Visualização de documento"
          class="document-preview-img"
          draggable="false"
          (load)="onImageLoad()"/>
    </div>
    <div *ngIf="documentPreviewUrl" class="d-flex justify-content-center align-items-center mt-1 preview-action-row">
      <ng-container *ngIf="isImage()">
        <button type="button" class="btn btn-secondary btn-sm" [disabled]="isLoading" (click)="rotateImage()"
          ngbTooltip="Rotacionar" container="body" rippleEffect>
          <span [data-feather]="'rotate-ccw'" class="mr-25"></span>Rotacionar
        </button>
        <button type="button" class="btn btn-secondary btn-sm btn-icon" [disabled]="isLoading || imageZoom <= minImageZoom"
          (click)="zoomOut()" ngbTooltip="Reduzir" container="body" aria-label="Reduzir" rippleEffect>
          <span [data-feather]="'zoom-out'"></span>
        </button>
        <button type="button" class="btn btn-secondary btn-sm btn-icon" [disabled]="isLoading || imageZoom >= maxImageZoom"
          (click)="zoomIn()" ngbTooltip="Ampliar" container="body" aria-label="Ampliar" rippleEffect>
          <span [data-feather]="'zoom-in'"></span>
        </button>
      </ng-container>
      <button type="button" class="btn btn-secondary btn-sm" [disabled]="isLoading"
        (click)="downloadAttachedDocument()" ngbTooltip="Baixar documento" container="body" rippleEffect>
        <span [data-feather]="'download'" class="mr-25"></span>Baixar
      </button>
    </div>
    <div *ngIf="!hasAttachedDocument" class="text-center flex flex-1 h-full flex-column justify-content-center align-items-center gap-2 text-muted">
      Nenhum documento anexado.
    </div>
    <div *ngIf="hasAttachedDocument && !documentPreviewUrl" class="text-center flex flex-1 h-full flex-column justify-content-center align-items-center gap-2">
      <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
      Carregando documento
    </div>
  </ng-template>

  <div *ngIf="!isInitializing && documentOnlyView" class="my-auto row">
    <div class="col-12 vertical-spacing d-flex flex-column document-only-preview">
      <ng-container *ngTemplateOutlet="documentPreview"></ng-container>
    </div>
  </div>

  <div *ngIf="!isInitializing && !documentOnlyView && showQualificationTypeSelection" class="my-auto row">
    <div class="col-6 vertical-spacing d-flex flex-column">
      <ng-container *ngTemplateOutlet="documentPreview"></ng-container>
    </div>
    <div class="col-6 qualification-type-selection d-flex flex-column justify-content-center">
      <h4 class="mb-2 text-center">Tipo de Qualificação</h4>
      <p class="text-muted mb-1 text-center">
        Confira o documento anexado ao lado antes de escolher o tipo de qualificação.
      </p>
      <p class="text-muted mb-4 text-center">
        Selecione como deseja qualificar esta ausência.
      </p>
      <div class="d-flex justify-content-center gap-2 flex-wrap">
        <button type="button" class="btn btn-outline-primary" (click)="selectQualificationType('LEGAL')">
          Ausência Legal
        </button>
        <button type="button" class="btn btn-outline-success" (click)="selectQualificationType('PRE_ABONO')">
          Pré-Abono
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="!isInitializing && !documentOnlyView && !showQualificationTypeSelection" class="my-auto row">
    <div class="col-6 vertical-spacing d-flex flex-column">
      <ng-container *ngTemplateOutlet="documentPreview"></ng-container>
    </div>

    <div class="col-6 row-form">
      <h4 [ngClass]="{'text-center': true,'mb-2': !onlyView}">
        {{ isPreAbonoMode ? 'Dados do Pré-Abono' : 'Dados do Afastamento' }}
      </h4>
      <p *ngIf="onlyView" class="text-center">Sequencial: {{excusedAbsence.sequential}}</p>
      <form class="form form-horizontal" #frm [formGroup]="form">
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="dateBegin">Data Início Afastamento</label>
              <input type="date" id="dateBegin" formControlName="dateBegin" required class="form-control" (change)="dateBeginChange()" />
              <app-error-msg [control]="form.controls['dateBegin']" [label]="'dateBegin'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="amountDays">Quantidade Dias</label>
              <input type="text" formControlName="amountDays" id="amountDays" class="form-control" (change)="amountDaysChange()" 
              (keypress)="omitChar($event)" [patterns]="numberPattern" [mask]="'D{2}'"/>
              <app-error-msg [control]="form.controls['amountDays']" [label]="'amountDays'">
              </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="dateEnd">Data Fim Afastamento</label>
              <input type="date" id="dateEnd" formControlName="dateEnd" class="form-control" (change)="dateEndChange()" />
              <app-error-msg [control]="form.controls['dateEnd']" [label]="'dateEnd'"> </app-error-msg>
            </div>
          </div>

          <ng-container *ngIf="isPreAbonoMode">
            <ng-container *ngIf="hasHourControlExcusedAbsence">
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label class="form-control-label" for="hourBegin">Hora Inicial</label>
                  <input type="time" id="hourBegin" formControlName="hourBegin" class="form-control" />
                </div>
              </div>
              <div class="col-md-6 col-12">
                <div class="form-group">
                  <label class="form-control-label" for="hourEnd">Hora Final</label>
                  <input type="time" id="hourEnd" formControlName="hourEnd" class="form-control" />
                </div>
              </div>
            </ng-container>
            <div class="col-md-12 col-12">
              <div class="form-group">
                <label class="form-control-label" for="bonusReasonId">Motivo de Abono</label>
                <ng-select
                  id="bonusReasonId"
                  formControlName="bonusReasonId"
                  [clearable]="false"
                  placeholder="Selecionar"
                  [compareWith]="compareValues"
                  [ngbTooltip]="getSelectedBonusReasonLabel()"
                  container="body">
                  <ng-option *ngFor="let item of bonusReasonOptions" [value]="item.id">
                    <span [attr.title]="item.title" container="body">{{ item.integrationCode }} - {{ item.title }}</span>
                  </ng-option>
                </ng-select>
                <small *ngIf="linkedToPreTreatment" class="text-muted">
                  Justificativa vinculada ao pré-tratamento. Você pode alterá-la se necessário.
                </small>
                <app-error-msg [control]="form.controls['bonusReasonId']" [label]="'bonusReasonId'"></app-error-msg>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!isPreAbonoMode">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"for="costCenter">Motivo Afastamento</label>
              <ng-select [compareWith]="compareValues" formControlName="absenceTypeId" [clearable]="false"
                placeholder="Selecionar" [ngbTooltip]="getSelectedTooltip(absenceTypes, 'absenceTypeId')" container="body">
                <ng-option *ngFor="let item of absenceTypes" [value]="item.value">
                  <span [attr.title]="item.label" container="body">{{ item.label }}</span>
                </ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['absenceTypeId']" [label]="'absenceTypeId'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"for="costCenter">Motivo Afastamento - ESocial</label>
              <ng-select [compareWith]="compareValues" formControlName="workLeaveTypeId" [clearable]="false"
                placeholder="Selecionar" [ngbTooltip]="getSelectedTooltip(workLeaveTypes, 'workLeaveTypeId')" container="body">
                <ng-option *ngFor="let item of workLeaveTypes" [value]="item.value">
                  <span [attr.title]="item.label" container="body">{{ item.label }}</span>
                </ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['workLeaveTypeId']" [label]="'workLeaveTypeId'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="birthplace">CID</label>
                &nbsp;<span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
              <ng-select [compareWith]="compareValues" formControlName="icdClassificationId" [clearable]="false" 
                (clear)="loadicdClassifications()" [typeahead]="icdClassificationInput" placeholder="Selecionar"
                [ngbTooltip]="getSelectedTooltip(icdClassifications, 'icdClassificationId')" container="body">
                <ng-option *ngFor="let item of icdClassifications" [value]="item.value">
                  <span [attr.title]="item.label" container="body">{{ item.label }}</span>
                </ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['icdClassificationId']" [label]="'icdClassificationId'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="issuerName">Nome Emitente</label>
              <input type="text" [dropSpecialCharacters]="false" (keypress)="omitChar($event)" [patterns]="pattern"
                [mask]="'B{100}'" formControlName="issuerName" name="issuerName" id="issuerName" class="form-control"
               placeholder="Nome emitente" uppercase/>
              <app-error-msg [control]="form.controls['issuerName']" [label]="'issuerName'">
              </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="issuerCRM">Conselho Emitente</label>
              <ng-select [clearable]="false" id="issuerCRM" formControlName="issuerCRM">
                <ng-option [value]="''">Selecionar</ng-option>
                <ng-option [value]="'1'">CRM</ng-option>
                <ng-option [value]="'2'">CRO</ng-option>
                <ng-option [value]="'3'">RMS</ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['issuerCRM']" [label]="'issuerCRM'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="issuerNumber">Inscrição Emitente</label>
              <input type="text" name="issuerNumber" formControlName="issuerNumber" class="form-control"
                (keypress)="omitChar($event)" placeholder="00000000" [mask]="'99999999'" />
              <app-error-msg [control]="form.controls['issuerNumber']" [label]="'issuerNumber'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="issuerUF">UF Emitente</label>
              <ng-select id="issuerUF" formControlName="issuerUF" placeholder="Selecionar" [clearable]="false">
                <ng-option [value]="''">Selecionar</ng-option>
                <ng-option *ngFor="let state of stateOptions" [value]="state.value">{{state.label}}</ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['issuerUF']" [label]="'issuerUF'"> </app-error-msg>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="custom-control custom-switch">
              <p class="mb-50">Continua Sequencial?</p>
              <input type="checkbox" [checked]="isSequential" [disabled]="onlyView" class="custom-control-input" id="customSwitch10" (change)="isSequentialChange($event)"/>
              <label class="form-control-label"class="custom-control-label" for="customSwitch10">
                <span class="switch-icon-left"><i data-feather="check"></i></span>
                <span class="switch-icon-right"><i data-feather="x"></i></span>
              </label>
            </div>
          </div>
          <div *ngIf="isSequential" class="col-md-6 col-12">
            <div class="form-group">
              <label class="form-control-label"  for="sequentialReference">Sequencial de Continuação</label>
              <ng-select id="sequentialReference" formControlName="sequentialReference" placeholder="Selecionar"
               [clearable]="false" [ngbTooltip]="getSelectedTooltip(qualifiedAbsencesOptions, 'sequentialReference')">
                <ng-option [value]="''">Selecionar</ng-option>
                <ng-option *ngFor="let absence of qualifiedAbsencesOptions" [value]="absence.value">
                  <span [attr.title]="absence.label" container="body">{{ absence.label }}</span>
                </ng-option>
              </ng-select>
              <app-error-msg [control]="form.controls['sequentialReference']" [label]="'sequencial'"> </app-error-msg>
            </div>
          </div>
          </ng-container>
        </div>
      </form>
    </div>
  </div>
  <div *ngIf="documentOnlyView && !isInitializing" class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onDismiss()" rippleEffect>
      Fechar
    </button>
  </div>
  <div *ngIf="!isInitializing && !documentOnlyView && !onlyView && !showQualificationTypeSelection" class="modal-footer">
    <button type="button" [disabled]="isLoading" class="btn btn-outline-secondary" (click)="onDismiss()" rippleEffect>
      Fechar
    </button>
    <button [disabled]="isLoading" type="button" (click)="openReproveAbsence()" class="btn btn-gradient-danger" rippleEffect>
      Reprovar <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
    <button type="button" [disabled]="isLoading" (click)="onConfirm()" class="btn btn-gradient-success" rippleEffect>
      Qualificar <span *ngIf="isLoading" class="spinner-border spinner-border-sm mr-1"></span>
    </button>
  </div>
</div>
</div>
